module.exports = __webpack_public_path__ + "img/alat_by_wema.7fe15af3.svg";